exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width: 500px){#checkout.checkout--theme-highlandsport .flex16{-ms-flex-direction:column;flex-direction:column}#checkout.checkout--theme-highlandsport .flex16 .checkout-heading{display:none}#checkout.checkout--theme-highlandsport .flex16 .checkout-logo{-ms-flex-item-align:center;align-self:center;margin:0;width:75%}}", ""]);

// exports
